// extracted by mini-css-extract-plugin
export default {"section_card":"SkeletonCardsGrid_section_card__GLZfj","skeleton":"SkeletonCardsGrid_skeleton__56zW8"};